import type { IntegrationVendor } from '@carboncopyco/types';
import type { FC } from 'react';
import { HubspotNameLogo, SalesforceNameLogo } from './assets';

export const integrationVendorNameToTitleMap: Record<
  IntegrationVendor,
  string
> = {
  salesforce: 'Salesforce',
  hubspot: 'Hubspot',
  slack: 'Slack',
  google_calendar: 'Google Calendar',
};

export const integrationVendorNameToIconMap: Record<
  Extract<IntegrationVendor, 'salesforce' | 'hubspot'>,
  FC
> = {
  salesforce: SalesforceNameLogo,
  hubspot: HubspotNameLogo,
};
